'use strict'; /*jslint react:true*/
import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {Root as Notif_root} from '@pub/comp/notif_system';
import {Suspense} from '@pub/lazy.js';
import {ROUTES} from '@pub/constants.js';
import {Auth, ACTION} from '@pub/features/auth';

const get_su = ()=><Auth action={ACTION.SIGNUP}/>;
const get_si = ()=><Auth action={ACTION.SIGNIN}/>;
const get_rs = ()=><Auth action={ACTION.RESET}/>;

export default function Auth_selector(){
    return <Suspense page_height>
      <Switch>
        <Route path={ROUTES.AUTH_SIGNUP} exact component={get_su}/>
        <Route path={ROUTES.AUTH_SIGNIN} exact component={get_si}/>
        <Route path={ROUTES.AUTH_RESET} exact component={get_rs}/>
        <Redirect to={ROUTES.AUTH_SIGNUP}/>
      </Switch>
      <Notif_root/>
    </Suspense>;
}
